"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useSendReaction = void 0;
var react_1 = __importDefault(require("react"));
var EditMessageBP = __importStar(require("@hiyllo/omni-common/src/blueprints/chat/edit-message"));
var use_message_reactions_1 = require("./use-message-reactions");
var use_send_message_1 = require("./use-send-message");
var omni_continuity_1 = require("@hiyllo/omni-continuity");
function useSendReaction(message) {
    var seamlessClient = (0, omni_continuity_1.useClient)();
    var self = (0, omni_continuity_1.useSelf)();
    var reactions = (0, use_message_reactions_1.useMessageReactions)(message.uuid).reactions;
    var sendMessage = (0, use_send_message_1.useSendMessage)();
    var editMessageMutation = seamlessClient.useMutation(EditMessageBP);
    var react = react_1["default"].useCallback(function (reaction) {
        var _a;
        var existing = reactions.find(function (r) { var _a; return r.senderId === self.userId && !r.content.encrypted && ((_a = r.content.reaction) === null || _a === void 0 ? void 0 : _a.reaction) === reaction; });
        if (existing) {
            void editMessageMutation.call({
                messageUUID: existing.uuid,
                content: {
                    encrypted: false,
                    text: null,
                    image: null,
                    file: null,
                    video: null,
                    reaction: null
                }
            });
        }
        else {
            void sendMessage.call({
                content: {
                    encrypted: false,
                    text: null,
                    image: null,
                    file: null,
                    video: null,
                    reaction: {
                        type: 'reaction',
                        reaction: reaction,
                        reactionTo: {
                            messageUUID: message.uuid,
                            messageTextPreview: message.content.encrypted ? '' : ((_a = message.content.text) !== null && _a !== void 0 ? _a : 'an attachment')
                        }
                    }
                },
                chatUUID: message.chatUUID,
                idp: Math.random().toString()
            });
        }
    }, [reactions]);
    return react;
}
exports.useSendReaction = useSendReaction;
